import { render } from "./AcceptancePaymentDialog.vue?vue&type=template&id=68e25c34&scoped=true"
import script from "./AcceptancePaymentDialog.vue?vue&type=script&lang=ts"
export * from "./AcceptancePaymentDialog.vue?vue&type=script&lang=ts"

import "./AcceptancePaymentDialog.vue?vue&type=style&index=0&id=68e25c34&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-68e25c34"

export default script